import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil';
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from 'components/cosmos/dropdown';
import { I18n, translate } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import PropTypes from 'prop-types';

import { ClassDeleteModal } from './classDeleteModal';

import './ClassListViewActions.scss';

const sendEvent = (category, classId) => {
  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      category,
      action: EVENTS_INTERACTIONS.CLICK,
      label: `${EVENTS_LABELS.CLASS.CLASS_ID}=${classId}`
    })
  });
};

const ClassListViewActions = ({ classItem, t }) => {
  const [currentAction, setCurrentAction] = useState({ showModal: false });

  const { showModal, classId } = currentAction;

  const handleMoreItems = (classId) => {
    setCurrentAction((state) => ({ ...state, classId }));

    sendEvent(EVENTS_CATEGORY.CLASS.VIEW_MORE_ITEMS, classId);
  };

  const handleEdit = () => {
    if (classId) {
      sendEvent(EVENTS_CATEGORY.CLASS.EDIT_CLASS, classId);
    }
  };

  const handleDelete = () => {
    setCurrentAction((state) => ({ ...state, showModal: true }));

    if (classId) {
      sendEvent(EVENTS_CATEGORY.CLASS.DELETE_CLASS, classId);
    }
  };

  const handleClose = () => {
    setCurrentAction({ showModal: false });
  };

  return (
    <>
      <Dropdown className="class_action">
        <button
          slot="button"
          className="hot-button _rounded-circle _border-0 _bg-transparent _w-7 _h-7 dropdown__button"
          title={t('general.view_more')}
          onClick={() => handleMoreItems(classItem.id)}
          data-test="more-items-button"
        >
          <FontAwesomeIcon icon={faEllipsisV} className="_text-gray-600" />
        </button>
        <Dropdown.MenuItem>
          <Link
            to={ROUTES.CLASS.EDIT.replace(':id', classItem.id)}
            className="_font-weight _text-decoration-none _text-gray-700 _text-left _d-block _p-0"
            onClick={handleEdit}
          >
            <FontAwesomeIcon icon={faPencil} className="_mr-3" />
            <I18n label="general.edit" />
          </Link>
        </Dropdown.MenuItem>
        <Dropdown.MenuItem>
          <button
            className="hot-button _border-0 _bg-transparent _text-left _w-full _p-0"
            onClick={handleDelete}
            disabled={classItem.defaultClass}
          >
            <FontAwesomeIcon icon={faTrash} className="_mr-3" />
            <I18n label="general.exclude" />
          </button>
        </Dropdown.MenuItem>
      </Dropdown>

      {showModal && classId && (
        <ClassDeleteModal onClose={handleClose} classId={classId} />
      )}
    </>
  );
};

ClassListViewActions.propTypes = {
  classItem: PropTypes.object,
  t: PropTypes.func
};

export default translate()(ClassListViewActions);
